import { ReactNode, useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { isPreviewEnvironment } from "@/utils/environment.utils";

interface RecaptchaProviderProps {
  children: ReactNode;
}

export const RecaptchaProvider = ({ children }: RecaptchaProviderProps) => {
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  const isPreview = isPreviewEnvironment();

  useEffect(() => {
    if (isPreview) return;

    // Ocultar o badge padrão do reCAPTCHA globalmente
    const style = document.createElement("style");
    style.id = "recaptcha-hide-badge";
    style.textContent = `
      .grecaptcha-badge { 
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
        display: none !important;
      }
    `;

    // Remover estilo existente se houver
    const existingStyle = document.getElementById("recaptcha-hide-badge");
    if (existingStyle) {
      document.head.removeChild(existingStyle);
    }

    document.head.appendChild(style);

    return () => {
      const styleElement = document.getElementById("recaptcha-hide-badge");
      if (styleElement && document.head.contains(styleElement)) {
        document.head.removeChild(styleElement);
      }
    };
  }, [isPreview]);

  if (!siteKey || isPreview) {
    return <>{children}</>;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default RecaptchaProvider;
